// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LA NUBE · IR A LOS PACKS DE ESPACIO (fase 5b, 1-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Los packs de espacio (components/nube/EspacioPacks.jsx) viven en Tu cuenta de Biango, en el bloque con id ANCLA_PACKS.
//  El botón «Contratar más espacio» de la Nube (components/nube/EspacioNube.jsx) lleva ahí SIN recargar la aplicación:
//  cambia la dirección y avisa al enrutador con un `popstate` (el mismo aviso que da el botón Atrás del navegador), así
//  que no hace falta meter el enrutador en un componente que las guardias montan sin él.
export const ANCLA_PACKS = 'espacio'
export const RUTA_PACKS = '/cuenta-biango#' + ANCLA_PACKS
// t464 · B-2142 · AMPLIAR EN UN PASO: desde el aviso de «espacio lleno», a los packs CON la ventana de firmar el pack que se
// recomienda ya abierta (components/nube/EspacioPacks.jsx la abre al ver ?ampliar=1, si quien entra puede contratarlo).
export const RUTA_AMPLIAR = '/cuenta-biango?ampliar=1#' + ANCLA_PACKS

export function irALosPacks(ventana, { ampliar = false } = {}) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  if (!w) return false
  const ruta = ampliar ? RUTA_AMPLIAR : RUTA_PACKS
  try {
    // El estado con la forma que usa el enrutador ({ usr, key, idx }), para que Atrás vuelva a la Nube.
    const antes = w.history.state || {}
    const estado = { usr: null, key: Math.random().toString(36).slice(2, 10), idx: typeof antes.idx === 'number' ? antes.idx + 1 : null }
    w.history.pushState(estado, '', ruta)
    w.dispatchEvent(new w.PopStateEvent('popstate', { state: estado }))
    return true
  } catch (_) {
    try { w.location.assign(ruta); return true } catch (__) { return false }
  }
}

// ¿Se llega pidiendo ampliar? Pura: lee una cadena «?…».
export const pideAmpliar = (search) => new URLSearchParams(String(search || '')).get('ampliar') === '1'
